var exports = {
  "T": "StackEntries__cqlocC",
};

module.exports = exports;
